import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-page">
   {/* Header - Same as Home Page */}
<div className="header">
  <div className="header-content">
    <div className="logo">
      <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
        <img src="/logo.png" alt="Airgati" className="logo-image" />
      </a>
    </div>
    <div className="nav">
   {/*   <a href="/#how-it-works">How it Works</a> */}
      <a href="/#features">Features</a>
      <a href="/#pricing">Pricing</a>
    </div>
    <div className="header-actions">
      <a href="/" className="sign-in-btn" style={{ textDecoration: 'none' }}>
        Back to Home
      </a>
    </div>
  </div>
</div>

{/* Page Title Section */}
<div className="page-title-section">
  <h1>Disclaimer</h1>
  <p className="last-updated">Last Updated: December 2024</p>
</div>

      <div className="privacy-content">
        
        <div className="intro">
          <p><strong>Welcome to Airgati.com</strong> ("Airgati", "we", "our", or "us").</p>
          <p>AirGati.com (“AirGati”, “we”, “us”, or “our”) is an AI-powered travel search and recommendation platform that helps users explore flight options, hotel options, and travel itineraries sourced from third-party providers. AirGati does not operate as a travel agency, booking agent, airline, hotel operator, or tour provider.</p>
          <p>By accessing or using our Services, you acknowledge that you have read, understood, and agree to the practices described below.</p>
        </div>

        <section>
          <h2>1. No Direct Booking or Ticket Issuance</h2>
          <p>AirGati does not sell, issue, reissue, or modify airline tickets, hotel reservations, or travel packages. All bookings are completed on third-party websites to which users may be redirected. Any transaction, payment, cancellation, refund, or customer support request must be handled directly with the respective airline, hotel, or service provider.</p>
                   
        </section>

        <section>
          <h2>2. Price Accuracy & Availability</h2>
          <p>Flight fares, hotel prices, availability, schedules, seat classes, baggage rules, and taxes displayed on AirGati are indicative only and may:</p>
          <ul>
            <li>Change frequently without notice</li>
            <li>Vary by location, device, time, or provider</li>
            <li>Differ from final prices shown on third-party booking platforms</li>
          </ul>
          <p className="highlight">AirGati does not guarantee price accuracy, fare availability, or booking confirmation. The final price and terms are always determined by the third-party provider at the time of booking.</p>
        </section>

        <section>
          <h2>3. Third-Party Content & Affiliate Links</h2>
          <p>AirGati aggregates and displays content obtained from third-party data sources, APIs, affiliates, and travel providers. We do not control, verify, or guarantee the accuracy, completeness, legality, or reliability of third-party content.
Some links on AirGati may be affiliate links, meaning we may earn a commission if a user completes a booking through a partner website, at no additional cost to the user.</p>
       </section>

        <section>
          <h2>4. AI-Generated Itineraries & Recommendations</h2>
          <p>AirGati may provide AI-generated travel itineraries, route suggestions, hotel recommendations, or travel insights for informational purposes only. These recommendations:</p>
          <ul>
            <li>Are not personalized professional advice</li>
            <li>May not account for visa requirements, health advisories, local laws, weather, strikes, or unforeseen events</li>
            <li>Should be independently verified by the user before making travel decisions</li>
          </ul>
          <p>AirGati is not responsible for missed connections, schedule changes, accommodation issues, or travel disruptions resulting from reliance on AI-generated suggestions.</p>
        </section>

        <section>
          <h2>5. No Liability</h2>
          <p>To the fullest extent permitted by law, AirGati shall not be liable for:</p>
          <ul>
            <li>Financial losses, booking errors, or price discrepancies</li>
            <li>Cancellations, delays, overbookings, or service failures</li>
            <li>Errors, omissions, or inaccuracies in listings or recommendations</li>
            <li>Any damages arising from use of third-party services</li>
    
          </ul>
          <p><em>Use of AirGati is entirely at the user’s own risk.</em></p>
        </section>

        <section>
          <h2>6. External Websites</h2>
          <p>AirGati may contain links to external websites that are not owned or controlled by us. We are not responsible for the content, privacy practices, or terms of those websites.</p>
        </section>

        <section>
          <h2>7. Acceptance of Disclaimer</h2>
          <p>By using AirGati.com, you acknowledge that you have read, understood, and agreed to this Disclaimer and all related terms.</p>
        </section>

        <section>
          <h2>8. Contact InformationS</h2>
          <p>If you have questions regarding this Disclaimer, please contact:</p>
          <ul>
            <li>📧 support@airgati.com</li>
            <li>🌐 https://www.airgati.com</li>
            
          </ul>
          
        </section>

        

        

      </div>

      <div className="privacy-footer">
        <p>&copy; 2024 Airgati.com. All rights reserved.</p>
        <a href="/">Return to Home</a>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
